import React, { useEffect, useState } from 'react';
import { Check } from 'react-bootstrap-icons';
import TrashIcon from '../../../assets/img/button-icons/trash-red.svg';
import CareMapprIconButton from '../Button/CareMapprIconButton';
import CareMapprTextField from '../Inputs/textField/CareMapprTextField';
import './editable-label.css';
import { EditPenOutline } from '../Icons';

export interface EditableLabelProps {
  id: string | number;
  label: string;
  onSave?: (value: string, id: string | number) => void;
  placeholder?: string;
  className?: string;
  canEdit?: boolean;
  canDelete?: boolean;
  onRequestDelete?: (id: string | number) => void;
  alwaysEditing?: boolean;
  isForNewSection?: boolean;
}

const EditableLabel: React.FC<EditableLabelProps> = ({
  id,
  label,
  onSave,
  placeholder = '',
  className = '',
  canEdit = false,
  canDelete = false,
  onRequestDelete,
  alwaysEditing = false,
  isForNewSection = false,
}) => {
  const [isEditing, setIsEditing] = useState<boolean>(alwaysEditing);
  const [inputValue, setInputValue] = useState<string>(label);

  useEffect(() => {
    setInputValue(label);
  }, [label]);

  useEffect(() => {
    if (alwaysEditing) setIsEditing(true);
  }, [alwaysEditing]);

  const handleEditClick = () => {
    if (!canEdit) return;
    setIsEditing(true);
  };

  const handleSaveClick = (e: React.MouseEvent) => {
    e.preventDefault();
    onSave?.(inputValue, id);
    if (!alwaysEditing) {
      setIsEditing(false);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = e.target.value;
    setInputValue(nextValue);
    if (isForNewSection) {
      onSave?.(nextValue, id);
    }
  };

  const showDelete = Boolean(canDelete);

  return (
    <div className={className}>
      {isEditing ? (
        <div className="d-flex align-items-center gap-2">
          <CareMapprTextField
            className="mt-3"
            value={inputValue}
            onChange={handleInputChange}
            placeholder={label || placeholder}
          />
          {!isForNewSection && (
            <CareMapprIconButton
              className="mt-auto mb-0"
              icon={<Check size={18} />}
              onClick={handleSaveClick}
            />
          )}
        </div>
      ) : (
        <div className="editable-label-display">
          <span className="ellipsis fw-semibold">{label}</span>
          {canEdit ? (
            <button onClick={handleEditClick}>
              <EditPenOutline />
            </button>
          ) : null}
          {showDelete ? (
            <button
              onClick={(e) => {
                e.preventDefault();
                onRequestDelete?.(id);
              }}
            >
              <img src={TrashIcon} alt="trash icon" className="editable-icon" />
            </button>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default EditableLabel;
